import React, { createContext, useContext, useState } from 'react';

const BottomNavContext = createContext({
  isBottomNavVisible: true,
  setBottomNavVisible: () => {},
});

export const useBottomNav = () => {
  const context = useContext(BottomNavContext);
  if (!context) {
    throw new Error('useBottomNav must be used within BottomNavProvider');
  }
  return context;
};

export const BottomNavProvider = ({ children }) => {
  const [isBottomNavVisible, setBottomNavVisible] = useState(true);

  return (
    <BottomNavContext.Provider value={{ isBottomNavVisible, setBottomNavVisible }}>
      {children}
    </BottomNavContext.Provider>
  );
};

